import { render } from "./ClienteLoginView.vue?vue&type=template&id=39d5c743"
import script from "./ClienteLoginView.vue?vue&type=script&lang=js"
export * from "./ClienteLoginView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__